import * as fromActions from '../types'

export const initialState = {
  detail: null,
  status: 'none',
  error: null,
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case fromActions.GET_EXCEPTION_ISSUE_REQUEST:
      return {
        detail: null,
        status: 'processing',
        error: null,
      }
    case fromActions.GET_EXCEPTION_ISSUE_SUCCESS: {
      const detail =
        action.payload?.item ??
        action.payload?.data ??
        action.payload ??
        null
      return {
        detail,
        status: 'processed',
        error: null,
      }
    }
    case fromActions.GET_EXCEPTION_ISSUE_ERROR:
      return {
        detail: null,
        status: 'error',
        error: action.error || 'Failed to fetch exception issue details.',
      }
    case fromActions.RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
